import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import routes from '../config/routes';
import AppRoute from '../components/AppRoute';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles';
import {theme} from '../config/theme';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from "../context";
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Box from '@mui/material/Box';

function App() {
  return (
      <ThemeProvider theme={theme}>
        <ToastContainer position="top-center" hideProgressBar={true} autoClose={5000} />
        <CssBaseline />
        <AuthProvider>
          <BrowserRouter>
            <Box sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              minHeight: '100vh' 
            }}>
              <Navbar />
              <Box sx={{ flexGrow: 1 }}>
                <Routes>
                  {routes.map(({component: Component, path, isPrivate}) => (
                    <Route
                      key={path}
                      path={path}
                      element={<AppRoute
                        isPrivate={isPrivate}
                        Component={Component}
                      />}
                    />
                  ))}
                </Routes>
              </Box>
              <Footer />
            </Box>
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
  );
}

export default App;
